import { render, staticRenderFns } from "./LocalNovo.vue?vue&type=template&id=e8fba6c0&scoped=true&"
import script from "./LocalNovo.vue?vue&type=script&lang=js&"
export * from "./LocalNovo.vue?vue&type=script&lang=js&"
import style0 from "./LocalNovo.vue?vue&type=style&index=0&id=e8fba6c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8fba6c0",
  null
  
)

export default component.exports